import { createSelector } from '@opengov/compose-app/reselect';
import { EReportActions } from '@opengov/reporting-types';

import { selectStandardTemplateFeatureFlag } from '../../common/flags';

import { selectAllowedActions } from './selectReportExplorerState';

export const selectCanManageAccess = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.ManageReportGrants))
);

export const selectCanViewAccess = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.ViewReportGrants))
);

export const selectCanDeleteReport = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.DeleteReport))
);

export const selectCanEditVisibility = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.SetReportVisibility))
);

export const selectCanEditReport = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.EditReport))
);

export const selectCanEditSavedViews = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.EditSavedViews))
);

export const selectCanAddSavedViews = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.AddSavedViews))
);

export const selectCanDeleteSavedViews = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.DeleteSavedViews))
);

export const selectCanViewReport = createSelector(selectAllowedActions, (allowedActions) =>
  Boolean(allowedActions.get(EReportActions.View))
);

export const selectCanTemplatizeStandard = createSelector(selectStandardTemplateFeatureFlag, (flag) => flag);
